import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import SearchOptions from "datalign-module-template/models/search-options";
import { useEasierTheme } from "datalign-themes";
import React, { useEffect } from "react";
import { MaterialIcon } from "ui-widgets";

const NTSortBy = ({
  searchOptions,
  onOptionsChange,
}: {
  searchOptions: SearchOptions;
  onOptionsChange: (searchOptions: SearchOptions) => void;
}) => {
  const [sort, setSort] = React.useState<string>();
  const easierTheme = useEasierTheme();

  const handleSort = (
    event: React.MouseEvent<HTMLElement>,
    newSort: string,
  ) => {
    if (newSort !== null) {
      setSort(newSort);
      onOptionsChange({
        ...searchOptions,
        order_by: {
          column_name: newSort,
          order: searchOptions.order_by.order || "desc",
        },
      });
    } else {
      // Flip order
      onOptionsChange({
        ...searchOptions,
        order_by: {
          ...searchOptions.order_by,
          order: searchOptions.order_by.order !== "desc" ? "desc" : "asc",
        },
      });
    }
  };

  useEffect(() => {
    setSort(searchOptions.order_by.column_name);
  }, [searchOptions.order_by.column_name]);

  return (
    <ToggleButtonGroup
      aria-label="Sort by group"
      sx={{
        borderRadius: "2px",
        "&.Mui-selected, &.Mui-selected:hover": {
          backgroundColor: easierTheme?.Colour.PrimaryContainer(),
        },
      }}
      onChange={handleSort}
      value={sort}
      color={"primary"}
      exclusive
      size="small"
    >
      <ToggleButton
        value="title"
        // sx={{
        //   backgroundColor:
        //     searchOptions.order_by.column_name === "title"
        //       ? easierTheme?.Colour.PrimaryContainer()
        //       : undefined,
        // }}
      >
        <MaterialIcon icon="sort" />
        <MaterialIcon
          icon="arrow_upward"
          style={{
            transform:
              searchOptions.order_by.order === "desc"
                ? "rotate(180deg)"
                : "rotate(360deg)",
            transitionDuration: "0.3s",
          }}
        />
        Asset
      </ToggleButton>
      <ToggleButton
        value="updated_at"
        // sx={{
        //   backgroundColor:
        //     searchOptions.order_by.column_name === "updated_at"
        //       ? easierTheme?.Colour.PrimaryContainer()
        //       : undefined,
        // }}
      >
        <MaterialIcon icon="sort" />
        <MaterialIcon
          icon={"arrow_upward"}
          style={{
            transform:
              searchOptions.order_by.order === "desc"
                ? "rotate(180deg)"
                : "rotate(360deg)",
            transitionDuration: "0.3s",
          }}
        />
        Date
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default NTSortBy;
